/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is molecular weight the same as molar mass?`)
};

const es_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es el peso molecular lo mismo que la masa molar?`)
};

const de_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Molekulargewicht dasselbe wie molare Masse?`)
};

const nl_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is molecuulgewicht hetzelfde als molaire massa?`)
};

const fr_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La masse moléculaire est-elle la même chose que la masse molaire ?`)
};

const it_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il peso molecolare è uguale alla massa molare?`)
};

const pt_br2_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso molecular é o mesmo que massa molar?`)
};

const pt_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A massa molecular é o mesmo que a massa molar?`)
};

const ja_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量とモル質量は同じですか？`)
};

const zh_mw_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量与摩尔质量相同吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_faq_q4", locale)
	if (locale === "en") return en_mw_faq_q4(inputs)
	if (locale === "es") return es_mw_faq_q4(inputs)
	if (locale === "de") return de_mw_faq_q4(inputs)
	if (locale === "nl") return nl_mw_faq_q4(inputs)
	if (locale === "fr") return fr_mw_faq_q4(inputs)
	if (locale === "it") return it_mw_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_mw_faq_q4(inputs)
	if (locale === "pt") return pt_mw_faq_q4(inputs)
	if (locale === "ja") return ja_mw_faq_q4(inputs)
	return zh_mw_faq_q4(inputs)
};